module.exports = __webpack_public_path__ + "img/transporeon-logo-small.e5d71165.svg";